/**
 * Filled cart drawer — sticky checkout banner when main checkout is out of view
 * Figma: appears when summary checkout isn't visible; hides when it is.
 */
(function () {
  const SELECTORS = {
    drawer: '[data-cart-drawer]',
    body: '[data-cart-drawer-body]',
    checkout: '[data-cart-checkout-observe]',
    sticky: '[data-sticky-checkout]',
    stickyBtn: '[data-sticky-checkout-btn]',
    stickyQty: '[data-sticky-cart-qty]',
    stickyTotal: '[data-sticky-cart-total]',
    itemsQty: '[data-cart-items-qty]',
    totalPrice: '[data-cart-total-price]',
    foot: '[data-foot-holder]',
  };

  const CLASSES = {
    visible: 'is-visible',
    hidden: 'hidden',
  };

  let observer = null;
  let mutationObserver = null;

  function syncStickyContent() {
    const sticky = document.querySelector(SELECTORS.sticky);
    if (!sticky) return;

    const qtyEl = document.querySelector(SELECTORS.itemsQty);
    const totalEl = document.querySelector(SELECTORS.totalPrice);
    const stickyQty = sticky.querySelector(SELECTORS.stickyQty);
    const stickyTotal = sticky.querySelector(SELECTORS.stickyTotal);
    const foot = document.querySelector(SELECTORS.foot);

    if (foot) {
      sticky.classList.toggle(CLASSES.hidden, foot.classList.contains(CLASSES.hidden));
    }

    if (stickyQty && qtyEl) {
      const match = (qtyEl.textContent || '').trim().match(/(\d+)/);
      stickyQty.textContent = match ? match[1] : '0';
    }

    if (stickyTotal && totalEl) {
      stickyTotal.innerHTML = totalEl.innerHTML;
    }
  }

  function setStickyVisible(visible) {
    const sticky = document.querySelector(SELECTORS.sticky);
    const foot = document.querySelector(SELECTORS.foot);
    if (!sticky) return;

    const shouldShow = Boolean(visible && foot && !foot.classList.contains(CLASSES.hidden));
    sticky.classList.toggle(CLASSES.visible, shouldShow);
    sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

    if (shouldShow) syncStickyContent();
  }

  function observeCheckout() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    const root = document.querySelector(SELECTORS.body);
    const checkout = document.querySelector(SELECTORS.checkout);
    if (!root || !checkout) {
      setStickyVisible(false);
      return;
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Show sticky whenever the summary checkout button is not in view
          setStickyVisible(!entry.isIntersecting);
        });
      },
      {
        root: root,
        threshold: 0,
        rootMargin: '0px',
      }
    );

    observer.observe(checkout);

    // Initial state after layout
    requestAnimationFrame(() => {
      const rect = checkout.getBoundingClientRect();
      const rootRect = root.getBoundingClientRect();
      const inView = rect.bottom > rootRect.top && rect.top < rootRect.bottom;
      setStickyVisible(!inView);
    });
  }

  function bindStickyCheckoutClick() {
    const stickyBtn = document.querySelector(SELECTORS.stickyBtn);
    if (!stickyBtn || stickyBtn.dataset.bound === 'true') return;

    stickyBtn.dataset.bound = 'true';
    stickyBtn.addEventListener('click', (event) => {
      event.preventDefault();
      const checkout = document.querySelector(SELECTORS.checkout);
      if (checkout) checkout.click();
    });
  }

  function bindMutations() {
    if (mutationObserver) {
      mutationObserver.disconnect();
      mutationObserver = null;
    }

    const totalEl = document.querySelector(SELECTORS.totalPrice);
    const qtyEl = document.querySelector(SELECTORS.itemsQty);
    const foot = document.querySelector(SELECTORS.foot);
    if (!totalEl && !qtyEl && !foot) return;

    mutationObserver = new MutationObserver(() => {
      syncStickyContent();
      const footEl = document.querySelector(SELECTORS.foot);
      if (footEl && footEl.classList.contains(CLASSES.hidden)) {
        setStickyVisible(false);
      }
    });

    if (totalEl) mutationObserver.observe(totalEl, { childList: true, characterData: true, subtree: true });
    if (qtyEl) mutationObserver.observe(qtyEl, { childList: true, characterData: true, subtree: true });
    if (foot) mutationObserver.observe(foot, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    bindStickyCheckoutClick();
    bindMutations();
    syncStickyContent();
    observeCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:cart:loaded', init);
  document.addEventListener('theme:cart:open', () => {
    requestAnimationFrame(init);
  });
  document.addEventListener('theme:cart:added', () => {
    requestAnimationFrame(init);
  });
})();
